export default {
  // Asignación de roles a usuarios
  assign: 'Assign',
  assign_role: 'Assign Role',
  assign_role_error: 'Error assigning the role',
  assign_role_success: 'Role assigned successfully',
  assign_role_none_created:
    'No assignment was created. Check that the locations belong to the selected franchise ' +
    'or that the assignment does not already exist.',
  assign_role_partial: 'Some assignments were not created. Review the selected locations and franchises.',
  assigned_roles: 'Assigned Roles',
  assign_role_more: '{locations} and {count} more',
  assign_role_reason_exist: 'already assigned: {locations}',
  assign_role_reason_franchise: 'outside the role\'s business unit: {locations}',
  assign_role_reason_exist_no_location: 'the role was already assigned in that business unit or organization',
  assign_role_none_prefix: 'No assignment was created —',
  assign_role_partial_prefix: 'Assignments created: {created}. Skipped —',

  // Listado y acciones masivas de usuarios
  users_options: 'Users',
  add_user: 'Add User',
  enable_users: 'Activate users',
  enable_users_message: 'You are about to activate all the users of this francquicia Are you sure you want to continue?',
  disable_users: 'Deactivate users',
  disable_users_message: 'You are about to deactivate all users of this francquicia Are you sure you want to continue?',

  // Datos personales del usuario (usado en users + profile)
  user: {
    first_name: 'Name',
    first_name_placeholder: 'e.g. John',
    last_name: 'Surname',
    last_name_placeholder: 'e.g. Doe',
    email: 'Mail',
    email_placeholder: "email{'@'}example.com",
    external_id: 'External ID',
    external_id_placeholder: '0000000',
    internal_id: 'Internal ID'
  },

  // Formulario de usuario (tipo de cuenta)
  user_is_demo: 'Demo User',
  is_real_mail: 'The Mail Is Real',
  user_is_aria: 'Aria User',
  user_security_title: 'Security and sessions',
  user_security_biometric_title: 'Disable biometric login',
  user_security_biometric_text: 'Keeps their session open; fingerprint or Face ID will stop working on their devices.',
  user_security_biometric_confirm: 'Disable biometric login for {user}? They stay logged in, but fingerprint or Face ID stops working.',
  user_security_sessions_title: 'Log out of all sessions',
  user_security_sessions_text: 'Logs them out on all their devices, including the web.',
  user_security_sessions_confirm: 'Log {user} out of all sessions? They will have to log in again on all devices.',
  user_security_biometric_done: 'Biometric login disabled',
  user_security_biometric_done_by: 'Disabled on {date} by {name}',
  user_security_biometric_done_at: 'Disabled on {date}',
  user_security_biometric_done_via_sessions_by: 'Disabled when their sessions were closed on {date} by {name}',
  user_security_biometric_done_via_sessions_at: 'Disabled when their sessions were closed on {date}',
  user_security_biometric_relogin: 'Disabled on {date}; they logged in afterwards and may have enabled it again.',
  user_security_sessions_done: 'Sessions closed',
  user_security_sessions_done_by: 'Closed on {date} by {name}',
  user_security_sessions_done_at: 'Closed on {date}',
  user_security_sessions_relogin: 'Closed on {date}; they logged in afterwards.',
  user_security_confirm_ok: 'Confirm',
  user_security_success: 'Done, it will be applied in a few seconds.',
  user_security_forbidden: 'You do not have permission to perform this action on this user.',
  user_security_error: 'The action could not be completed. Please try again.',

  // Resumen ejecutivo de Aria (insights periódicos, ver Chat.vue)
  user_is_aria_insights: 'Aria proactive insights',
  aria_executive_summary: 'Executive summary',
  aria_period_weekly: 'Weekly',
  aria_period_biweekly: 'Biweekly',
  aria_period_monthly: 'Monthly',

  // Tipos de usuario (filtros del listado)
  basic_users: 'Basics',
  standard_users: 'Standard',
  demo_users: 'Demo',

  // Exportar reporte de usuarios

  // Aviso de expiración de cuenta demo (mixin global currentUser.js + profile/organizations)
  demo_message: 'This account is demo and will be available until',
  demo_expiration: 'Your demo has expired',
  expiration_message: 'Your demo time has expired. For clarifications contact your administrator.',

  // Estado de cuenta demo de un usuario (consumido hoy solo desde Organization.vue)
  username: 'Alias',
  demo_expirated: 'The demo account expired on',
  demo_user_update: 'Updated demo user',
  demo_date_message: 'The demo period of the selected user has been updated',

  // Huérfanas migradas desde labels.js (sin consumidor confirmado, ver hallazgo Fase 2)
  user_is_basic: 'Basic User',
  aria_users: 'Aria',
  account_number: 'Account number',
  users_number: 'Number of users',
  exceed_users_limit: 'You can t create more users of this type, you ve reached your limit.',
  registration_problem: 'Error registering',
  demo_until: 'Demo until',
  export_header_franchise: 'Franquícia',
  download_report: 'Download User Report'
}
